// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"ImagesAccordion_imgWrapper__txynV","image":"ImagesAccordion_image__sgJHY"};